import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import styles from "./styles/ContactForm.module.css";

const SERVICE_ID  = "service_u2j8s4p";
const TEMPLATE_ID = "template_5yjj4te";
const PUBLIC_KEY  = "aCAlVaQugpvB3gu1g1kQq";

const phoneRegex = /^[+]?[0-9]{7,15}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validate(fields) {
  const errors = {};
  if (!fields.firstName.trim()) errors.firstName = "First name is required.";
  if (!fields.lastName.trim()) errors.lastName = "Last name is required.";
  if (!fields.company.trim()) errors.company = "Company name is required.";
  if (!fields.phone.trim()) errors.phone = "Phone number is required.";
  else if (!phoneRegex.test(fields.phone.trim())) errors.phone = "Enter a valid phone number.";
  if (!fields.email.trim()) errors.email = "Email is required.";
  else if (!emailRegex.test(fields.email.trim())) errors.email = "Enter a valid email address.";
  return errors;
}

export default function ContactForm() {
  const formRef = useRef(null);
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState({});
  const [fields, setFields] = useState({
    firstName: "", lastName: "", company: "", phone: "", email: "", requirement: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(fields);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setStatus("sending");
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(() => {
        setStatus("success");
        setFields({ firstName: "", lastName: "", company: "", phone: "", email: "", requirement: "" });
        setErrors({});
      })
      .catch(() => setStatus("error"));
  };

  return (
    <div className={styles.formWrap}>
      <span className={styles.eyebrow}>say hello</span>
      <h2 className={styles.heading}>Get in touch with us</h2>
      <p className={styles.text}>
        We&rsquo;d love to hear from you, provide you with more
        information, answer any questions that you may have or
        creative an effective solution for you.
      </p>

      <form className={styles.form} ref={formRef} onSubmit={handleSubmit} noValidate>
        <div className={styles.field}>
          <label htmlFor="firstName" className={styles.label}>First Name*</label>
          <input type="text" id="firstName" name="firstName" value={fields.firstName} onChange={handleChange} className={`${styles.input} ${errors.firstName ? styles.inputError : ""}`} />
          {errors.firstName && <span className={styles.errorText}>{errors.firstName}</span>}
        </div>
        <div className={styles.field}>
          <label htmlFor="lastName" className={styles.label}>Last Name*</label>
          <input type="text" id="lastName" name="lastName" value={fields.lastName} onChange={handleChange} className={`${styles.input} ${errors.lastName ? styles.inputError : ""}`} />
          {errors.lastName && <span className={styles.errorText}>{errors.lastName}</span>}
        </div>
        <div className={styles.field}>
          <label htmlFor="company" className={styles.label}>Company Name*</label>
          <input type="text" id="company" name="company" value={fields.company} onChange={handleChange} className={`${styles.input} ${errors.company ? styles.inputError : ""}`} />
          {errors.company && <span className={styles.errorText}>{errors.company}</span>}
        </div>
        <div className={styles.field}>
          <label htmlFor="phone" className={styles.label}>Phone Number*</label>
          <input type="tel" id="phone" name="phone" value={fields.phone} onChange={handleChange} className={`${styles.input} ${errors.phone ? styles.inputError : ""}`} />
          {errors.phone && <span className={styles.errorText}>{errors.phone}</span>}
        </div>
        <div className={styles.field}>
          <label htmlFor="email" className={styles.label}>Your Email*</label>
          <input type="email" id="email" name="email" value={fields.email} onChange={handleChange} className={`${styles.input} ${errors.email ? styles.inputError : ""}`} />
          {errors.email && <span className={styles.errorText}>{errors.email}</span>}
        </div>
        <div className={styles.field}>
          <label htmlFor="requirement" className={styles.label}>Tell us about your requirement</label>
          <textarea id="requirement" name="requirement" rows={4} value={fields.requirement} onChange={handleChange} className={styles.textarea} />
        </div>

        {status === "success" && <p className={styles.successMsg}>✅ Message sent successfully!</p>}
        {status === "error" && <p className={styles.errorMsg}>❌ Something went wrong. Please try again.</p>}

        <button type="submit" className={styles.submit} disabled={status === "sending"}>
          {status === "sending" ? "SENDING..." : "SEND"}
        </button>
      </form>
    </div>
  );
}
